import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Arrow from '../../img/icons/BBiconsRozbalit';
import { apiGet, getHostApi } from '../../store/apiWrapper';
import { newsActions } from '../../store/newsStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { Circles } from '../common/loadingComponent';
import Message from '../common/message';
import NewsContent from './newsContent';
import NewsFooter from './newsFooter';

import './news.css';

class NewsDetailComponent extends React.Component {
    state = {
        item: null,
        loading: false,
        error: null
    }

    render() {
        return (
            <div className='content-root' style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div className='news-detail-back'>
                    <Link to={`/news`} className='link-internal'>
                        <Arrow width='2em' height='2em' />
                        &nbsp;
                        <Translate id='News.Detail.Back' />
                    </Link>
                </div>
                {(this.state.loading === true || this.state.error) &&
                    <div className='news-detail-message'>
                        {this.state.loading === true && <Circles />}
                        {this.state.error && <Message type='error' message={this.state.error} />}
                    </div>
                }
                {!isNullOrUndefined(this.state.item) && this.renderNewsDetail()}
            </div>
        );
    }

    componentDidMount() {
        this.getNewsDetail();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location || prevProps.language !== this.props.language) {
            this.getNewsDetail();
        }
    }

    renderNewsDetail = () => {
        const { header, text, validFromFormated, annotation, seenFormated } = this.state.item;

        return (
            <div className="bb-news-widget">
                <div className="bb-news-widget-header-box">
                    <div className="bb-news-widget-header-content">
                        <span>{header}</span>
                    </div>
                </div>
                <NewsContent text={text} />
                <NewsFooter date={validFromFormated} annotation={annotation} seen={seenFormated} />
            </div>
        );
    }

    getNewsDetail = () => {
        this.setState({ item: null, loading: true, error: null });
        apiGet(`${getHostApi()}/api/account/news?id=${this.props.match.params.id}`, null,
            (n) => {
                this.setState({ item: n.data.length > 0 ? n.data[0] : null, loading: false, error: null });
                if (n.data.length > 0 && !n.data[0].seen)
                    this.props.updateNewsStatus([n.data[0].newsId]);
            },
            e => this.setState({ item: null, loading: false, error: this.props.translate('Common.Error') })
        );
    }
}

export default withLocalize(withRouter(connect(
    state => state.userContext,
    dispatch => bindActionCreators(newsActions, dispatch)
)(NewsDetailComponent)));
